module.exports = __webpack_public_path__ + "img/shebeijiance.eb6eeb51.svg";